import hamburger from './hamburger.svg'
import medium from "./medium.svg"
import logo from "./logo.png"
import portfolio from "./portfolio.png"
import floatingNotes from "./floatingNotes.png"
import bhauLang from "./bhaulang.png"

import clash from "./clash.png"
import clash1 from "./clash1.png"
import clash2 from "./clash2.png"
import clash3 from "./clash3.png"
import clash4 from "./clash4.png"
import clash5 from "./clash5.png"
import clash6 from "./clash6.png"
import clash7 from "./clash7.png"


import ncc from "./ncc.png"
import ncc1 from "./ncc1.png"
import ncc2 from "./ncc2.png"
import ncc3 from "./ncc3.png"
import ncc4 from "./ncc4.png"
import ncc5 from "./ncc5.png"
import rc1 from "./rc1.png"

import nginx1 from "./nginx1.png"
import nginx2 from "./nginx2.png"
import nginx3 from "./nginx3.png"
import nginx4 from "./nginx4.png"
import nginx5 from "./nginx5.png"

const clashImages = [clash1,clash2,clash3,clash4,clash5,clash6,clash7]
const rcImages = [ncc1,rc1,ncc2,ncc3,ncc4,ncc5]
const nginxImages = [nginx1,nginx2,nginx3,nginx4,nginx5]

export {
    hamburger,medium,logo,portfolio,floatingNotes,bhauLang,clashImages,rcImages,nginxImages
}